import FootballPaymentBalances from '../../Football/Admin/FootballPaymentBalances'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { Button, ListGroup } from 'react-bootstrap'
import * as s from './EliminatorPayments.scss'
import { getPayments } from '@severed-links/common.redherrings-reducers/eliminatorAdmin'
import { sumBy } from 'lodash'
import PlayerListItem from '../../Player/PlayerListItem'
import Modal from '@severed-links/common.modal'
import moment from 'moment-timezone'
import numeral from 'numeral'
import pluralize from 'pluralize'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import SeasonSelector from '../../Football/SeasonSelector'
import Confirm from '@severed-links/common.confirm'
import { deletePaymentLogItem } from '@severed-links/common.redherrings-reducers/footballAdmin'

const EliminatorPayments = () => {

    const dispatch = useDispatch()
    const params = useParams()
    const seasons = useSelector(state => state.eliminator.seasons || [])
    const seasonName = params.seasonName || null
    const season = seasons.find(i => i.seasonName === seasonName)
    const seasonId = (season || {}).seasonId || null
    const payments = useSelector(state => (state.eliminatorAdmin.paymentLogs || []).find(i => i.seasonName === seasonName) || { items: [] })
    const [isLoading, setLoading] = useState(false)
    const [txn, setTxn] = useState({})
    const [showDetail, setShowDetail] = useState(false)

    useEffect(() => { getPaymentList() }, [seasonId])

    const getPaymentList = () => {
        if (seasonId) {
            setLoading(true)
            dispatch(getPayments(seasonId))
            .then(() => setLoading(false))
        }
    }

    const showTransactionDetail = _txn => {
        setTxn(_txn)
        setShowDetail(true)
    }

    const deleteLogItem = _id => {
        setShowDetail(false)
        setTxn({})
        dispatch(deletePaymentLogItem(_id))
        .then(() => getPaymentList())
    }


    if (!payments || !seasons) return null
    const { items } = payments
    const paymentItems = items || []
    const totalAmount = sumBy(paymentItems, 'payment_amount')
    const _detailItems = txn && showDetail ? [
        { label: 'Player', value: `${txn.firstName} ${txn.lastName}` },
        { label: 'Email', value: txn.payer_email || txn.emailAddress || 'Not recorded' },
        { label: 'Payment method', value: txn.paymentMethod || 'PayPal' },
        { label: 'Reference', value: txn.paymentReference || '—' },
        { label: 'Note', value: txn.paymentNote || '—' },
        { label: 'Recorded by', value: txn.recordedByName || '—' },
        { label: 'Transaction ID', value: `${txn.txn_id}` },
        { label: 'Amount', value: numeral(txn.payment_amount).format('($0,0.00)') },
        { label: 'Payment Status', value: txn.payment_status },
        { label: 'Timestamp', value: moment(txn.entryDate).format('M/D/YYYY h:mm:ss A') },
    ] : []
    return (
        <div className={s.container}>
            <section className={s.pageHeader}>
                <div className={s.headerCopy}>
                    <div className={s.eyebrow}>Eliminator Admin</div>
                    <h2 className={s.title}>Payment Log</h2>
                    <div className={s.subtitle}>{seasonName} payment transactions</div>
                </div>
                <div className={s.headerActions}>
                    <Button className={s.refreshButton} variant='light' size='sm'
                        title='refresh payment log'
                        onClick={() => getPaymentList()}>
                        <FontAwesomeIcon name='rotate' spin={isLoading} />
                    </Button>
                    <SeasonSelector seasons={seasons} season={season} />
                </div>
            </section>

            <section className={s.summaryGrid}>
                <div className={s.summaryPill}>
                    <span>{paymentItems.length}</span>
                    {pluralize('entry', paymentItems.length)}
                </div>
                <div className={s.summaryPill}>
                    <span>{numeral(totalAmount).format('($0,0.00)')}</span>
                    total collected
                </div>
            </section>

            <FootballPaymentBalances key={seasonId} balances={payments.balances} applicationName='Eliminator'
                seasonId={seasonId} onSaved={getPaymentList} />
            <section className={s.paymentCard}>
                <div className={s.listHeader}>
                    <div>Player</div>
                    <div>Amount</div>
                </div>
                <ListGroup className={s.paymentList}>
                {paymentItems.map(i =>
                <PlayerListItem key={`payment-log-item-${i.txn_id}`}
                    className={s.paymentRow}
                    player={i}
                    detail={moment(i.entryDate).format('M/D/YYYY h:mm:ss A')}
                    rightDetail={<div className={s.amount}>{numeral(i.payment_amount).format('($0,0.00)')}</div>}
                    onClick={() => showTransactionDetail(i)} />
                )}
                {!paymentItems.length ? <ListGroup.Item className={s.emptyState}>No payments located</ListGroup.Item> : null}
                </ListGroup>
            </section>
            <Modal heading='Transaction Detail'
                className={s.detailModal}
                dialogClassName={s.detailDialog}
                bodyClass={s.detailBody}
                show={showDetail}
                showFooter={false}
                onClose={() => setShowDetail(false)}>
                <div className={s.detailContainer}>
                <div className={s.detailSummary}>
                    <div className={s.detailEyebrow}>Payment</div>
                    <div className={s.detailAmount}>{numeral(txn.payment_amount).format('($0,0.00)')}</div>
                    <div className={s.detailStatus}>{txn.payment_status}</div>
                </div>
                <ListGroup className={s.detailList}>
                {_detailItems.map((i, _index) => 
                <ListGroup.Item className={s.detailItem} key={`transaction-detail-${_index}`}>
                    <div className={s.content}>
                        <div className={s.label}>{i.label}</div>
                        <div className={s.value}>{i.value}</div>
                    </div>
                </ListGroup.Item>
                )}
                </ListGroup>
                <div className={s.deleteContainer}>
                    <Confirm variant='danger' onConfirm={() => deleteLogItem(txn._id)}
                        title={'Delete Payment Log Item'}
                        confirmText='delete log item'
                        body={'Are you sure you want to delete this payment log item?'}
                        buttonClassName={s.deleteButton} size='sm'
                        buttonIcon='times' buttonText='Delete log item' />
                </div>
                </div>
            </Modal>
        </div>
    )
}

export default EliminatorPayments
